import {Module, ModuleItem} from '@dms/api/shared';
import {moduleKeys} from '@dms/config';
import {featureFlags} from '@dms/feature-flags';
import {salesLeagueRoutes} from '@dms/routes';
import {permissions} from '@dms/shared';

import {SalesLeague} from './pages/SalesLeague/SalesLeague';
import {SalesLeagueBranchBoard} from './pages/SalesLeagueBranchBoard/SalesLeagueBranchBoard';

const content: ModuleItem[] = [
  {
    id: 'sales-league-repLeaderboard',
    routerProps: {
      path: salesLeagueRoutes.overview,
      element: <SalesLeague />,
    },
    layoutProps: {
      title: 'module.salesLeague.repLeaderboard',
      icon: 'action/stars',
    },
    requiredPermission: permissions.salesLeagueRead,
  },
  {
    id: 'sales-league-branchBoard',
    routerProps: {
      path: salesLeagueRoutes.branchBoard,
      element: <SalesLeagueBranchBoard />,
    },
    layoutProps: {
      title: 'module.salesLeague.branchBoard',
      icon: 'action/trending_up',
    },
    requiredPermission: permissions.salesLeagueBranchBoardRead,
  },
];

export const SalesLeagueModule: Module = {
  id: moduleKeys.salesLeague,
  requiredPermission: permissions.salesLeagueRead,
  requiredFeatureFlag: featureFlags.SALES_LEAGUE,
  layoutProps: {
    title: 'module.salesLeague.title',
    icon: 'action/stars',
  },
  routerProps: {
    path: salesLeagueRoutes.overview,
  },
  content,
};
